import { render, staticRenderFns } from "./saleRecord.vue?vue&type=template&id=54236db8&scoped=true"
import script from "./saleRecord.vue?vue&type=script&lang=js"
export * from "./saleRecord.vue?vue&type=script&lang=js"
import style0 from "./saleRecord.vue?vue&type=style&index=0&id=54236db8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54236db8",
  null
  
)

export default component.exports